import DownloadIcon from '../../assets/icons/download-icon-3.svg';

type ItemType = {
    path : string;
    name : string;
}

type DownloadListProps = {
  data : ItemType[];
}

const DownloadList = ({ data } : DownloadListProps) => {
  return (
    <div className="download-list">
      <ul>
        {data.map((item, index) => (
          <li key={index}>
            <a target='_blank' href={item.path}>{item.name}<img src={DownloadIcon} alt="" /></a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default DownloadList